<template>
  <div id="esnekcuzdan">
    <Loading v-if="loading"/>
    <div class="authContainer">
      <form @submit.prevent="submitForm">
        <h4 class="text-center">Para Yatırma</h4>
        <hr>
        <div v-if="showBankSelect" class="form-group">
          <label>Bank Seçiniz</label>
          <v-select label="name" :reduce="(i) => i._id" v-model="form.bankId" :options="banks" :filterBy="filterBank">
            <template #option="{ name }">
              <span>{{ name }}</span>
            </template>
            <template #selected-option="{ name }">
              <span>{{ name }}</span>
            </template>
          </v-select>
          <template v-if="errors.firstByRule('name', 'required')">
            <code class="help is-danger">Bu alan zorunludur.</code>
          </template>
        </div>
        <div class="form-group">
          <label>Ad & Soyad</label>
          <input autocomplete="off" v-validate="'required'" class="form-control text-box single-line" name="name" type="text" v-model="form.name">
          <template v-if="errors.firstByRule('name', 'required')">
            <code class="help is-danger">Bu alan zorunludur.</code>
          </template>
        </div>

        <div class="form-group">
          <label>Tutar</label>
          <input autocomplete="off" v-validate="'required'" class="form-control text-box single-line" id="amount" name="amount" type="number" v-model="form.amount">
          <template v-if="errors.firstByRule('amount', 'required')">
            <code class="help is-danger">Bu alan zorunludur.</code>
          </template>
        </div>
        <div>
          <b-button class="esnekButton" type="submit" variant="primary" block>Onayla</b-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Loading from "@/components/Loading";
import {createTransaction, getAvailableBanks} from "@/api/transaction";

import * as _ from 'lodash';
import crypto from 'crypto';

export default {
  components: {
    Loading
  },
  computed: {
    ...mapState({
      config: state => state.auth.config,
    }),
  },
  data() {
    return {
      showBankSelect: false,
      siteId: null,
      appKey: null,
      appSecret: null,
      form: {
        bankId: null,
        amount: null,
        userId: null,
        name: null,
        userName: null,
        processId: null,
      },
      signature: null,
      loading: true,
      banks: []
    }
  },
  methods: {
    generateUserName(name) {
      const charMap = {
        "İ": "i",
        "I": "i",
        "ı": "i",
        "Ç": "c",
        "ç": "c",
        "Ş": "s",
        "ş": "s",
        "Ö": "o",
        "ö": "o",
        "Ü": "u",
        "ü": "u",
        "Ğ": "g",
        "ğ": "g",
        "-": "",
        "_": "",
        "*": "",
        "/": ""
      };
      this.form.userName =  name.split("").map((w) => {
        return charMap[w] ? charMap[w] : w;
      }).join("").toLowerCase().replace(" ", "").replace(" ", "")
    },
    generateUserId() {
      this.form.userId = Math.random().toString().slice(2, 15) + Math.random().toString().slice(2, 5);
    },
    filterBank(option, label, search) {
      return (option.name || '').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          this.generateUserName(this.form.name);
          this.generateUserId();
          this.form.amount = this.form.amount.replace(",", ".");
          this.signature = this.createSignature();
          createTransaction(this.signature, this.appKey, this.form).then((response) => {
            const status = _.get(response, "data.data.status");
            if (status === "bankAccount_not_found") {
              alert("Banka hesabı bulunamadı. Lütfen daha sonra tekrar deneyiniz.");
            }
            if (status === "error_invalid_sign" || status === "error_invalid_bank") {
              alert("İşlem hatası oluştu. Lütfen daha sonra tekrar deneyiniz.");
            }
            if (status === "pending") {
              const redirection = _.get(response, "data.data.url", null);
              if (redirection) {
                window.location.href = redirection;
              } else {
                alert("İşlem hatası oluştu. Lütfen daha sonra tekrar deneyiniz.");
              }
            }
            this.loading = false;
            this.form = {
              bankId: null,
              amount: null,
              userId: null,
              name: null,
              userName: null,
              processId: null,
            };
          });
        }
      });
    },
    extractKey() {
      let code = this.$route.params.siteId;
      code = `${code}==`;
      try {
        let extract = atob(code);
        extract = _.split(extract, '.');
        this.siteId = extract[0];
        this.appKey = extract[1];
        this.appSecret = extract[2];
      } catch (e) {
        console.log(e);
      }
    },
    setProcessId() {
      this.form.processId = Math.random().toString().slice(2, 15) + Math.random().toString().slice(2, 5);
    },
    createSignature(payload) {
      const encodedRequest = new URLSearchParams(payload || this.form).toString();
      return crypto.createHmac("sha256", this.appSecret).update(encodedRequest).digest().toString('base64');
    },
  },
  mounted() {
    this.extractKey();
    this.setProcessId();
    setTimeout(() => {
      const signature = this.createSignature({});
      console.log(signature,this.appKey)
      getAvailableBanks(signature, this.appKey).then((response) => {
        const banks = response.data.data;
        if (banks.length === 1) {
          this.showBankSelect = false;
          this.form.bankId = banks[0]._id;
        } else {
          this.showBankSelect = true;
          this.banks = banks;
        }
        this.loading = false;
      })
    }, 1000);


  }
}
</script>
